<m-modal
    [canClose]="false"
    title="{{ 'coordinatorChoice.title' | translate }}"
>
    <ng-container body>
        <div class="coordinator-choice">
            <p class="coordinator-choice__subtitle">
                {{ "coordinatorChoice.subtitle" | translate }}
            </p>

            <div class="coordinator-choice__options">
                <button
                    class="coordinator-choice__option"
                    (click)="onJoinTeam()"
                >
                    <div class="coordinator-choice__icon coordinator-choice__icon--join">
                        <m-svg iconName="user" />
                    </div>

                    <div class="coordinator-choice__text">
                        <span class="coordinator-choice__option-title">
                            {{ "coordinatorChoice.joinTeam" | translate }}
                        </span>

                        <span class="coordinator-choice__option-description">
                            {{ "coordinatorChoice.joinTeamDescription" | translate }}
                        </span>
                    </div>

                    <m-svg
                        class="coordinator-choice__arrow"
                        iconName="back"
                    />
                </button>

                <button
                    class="coordinator-choice__option coordinator-choice__option--view"
                    (click)="onViewTeams()"
                >
                    <div class="coordinator-choice__icon coordinator-choice__icon--view">
                        <m-svg iconName="stopwatch" />
                    </div>

                    <div class="coordinator-choice__text">
                        <span class="coordinator-choice__option-title">
                            {{ "coordinatorChoice.viewTeams" | translate }}
                        </span>

                        <span class="coordinator-choice__option-description">
                            {{ "coordinatorChoice.viewTeamsDescription" | translate }}
                        </span>
                    </div>

                    <m-svg
                        class="coordinator-choice__arrow"
                        iconName="back"
                    />
                </button>
            </div>
        </div>
    </ng-container>
</m-modal>
